/* House of Zoomies — interactions. Idempotent: safe to load more than once. */
(function () {
  if (window.__hozInit) return;
  window.__hozInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wireStage(stage) {
    if (stage.dataset.hozWired) return;
    stage.dataset.hozWired = '1';
    var dog = stage.querySelector('.hoz-dog');
    if (!dog) return;
    function run() {
      if (reduce || dog.classList.contains('is-lap')) return;
      dog.classList.remove('hoz-dog--in');
      void dog.offsetWidth;
      dog.classList.add('is-lap');
    }
    dog.addEventListener('animationend', function () { dog.classList.remove('is-lap'); });
    dog.addEventListener('click', run);
    var btn = stage.querySelector('.hoz-zoombtn');
    if (btn) btn.addEventListener('click', run);
  }

  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        setTimeout(function () { e.target.classList.add('hoz-in'); }, (i % 4) * 90);
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }

  function wireReveals(root) {
    (root || document).querySelectorAll('[data-hoz-reveal]').forEach(function (el) {
      if (el.dataset.hozSeen) return;
      el.dataset.hozSeen = '1';
      if (io) { io.observe(el); } else { el.classList.add('hoz-in'); }
    });
  }

  function wireSignup(form) {
    if (form.dataset.hozWired) return;
    form.dataset.hozWired = '1';
    var input = form.querySelector('input[type="email"]');
    var note = form.parentElement && form.parentElement.querySelector('.hoz-fine');
    form.addEventListener('submit', function (ev) {
      var v = (input && input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        ev.preventDefault();
        if (note) { note.textContent = 'That address is missing something. Check it and try again.'; note.classList.add('hoz-fine--ok'); }
        if (input) input.focus();
      }
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('.hoz-stage').forEach(wireStage);
    (root || document).querySelectorAll('.hoz-signup form').forEach(wireSignup);
    wireReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
